import Cookies from "js-cookie";
import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import CreateDepartmentForm from "./components/deparments/CreateDepartmentForm";
import EditDepartmentForm from "./components/deparments/EditDepartmentForm";
import AdminRoute from "./components/routing/AdminRoute";
import Permissions from "./pages/Admin/Permissions";
import Clients from "./pages/Clients/Clients";
import CreateClientForm from "./pages/Clients/CreateClientForm";
import EditClientForm from "./pages/Clients/EditClientForm";
import Accountability from "./pages/Dashboards/Accountability/Accountability";
import ClientInsights from "./pages/Dashboards/ClientInsights";
import DueDateReport from "./pages/Dashboards/DueDateReport";
import EfileStatusReport from "./pages/Dashboards/EfileStatusReport";
import EmployeeProductionReport from "./pages/Dashboards/EmployeeProduction/EmployeeProductionReport";
import EmployeeServices from "./pages/Dashboards/EmployeeProduction/EmployeeServices";
import FilteredClients from "./pages/Dashboards/EmployeeWorkloadReport/FilteredClients";
import WorkloadReport from "./pages/Dashboards/EmployeeWorkloadReport/WorkloadReport";
import InactiveReport from "./pages/Dashboards/InactiveReport/InactiveReport";
import JobsReport from "./pages/Dashboards/JobsReport";
import JobsReportV2 from "./pages/Dashboards/JobsReportV2";
import RetentionReport from "./pages/Dashboards/RetentionReport/RetentionReport";
import ServiceInsights from "./pages/Dashboards/ServiceInsights";
import StatusReport from "./pages/Dashboards/StatusReport/StatusReport";
import TaxAgendaReport from "./pages/Dashboards/TaxAgendaReport";
import CreateEmployee from "./pages/Employees/CreateEmployee";
import EditEmployeeForm from "./pages/Employees/EditEmployee";
import EmployeesPage from "./pages/Employees/EmployeesPage";
import AcceptInvitation from "./pages/AcceptInvitation/Index";
import ForgotPassword from "./pages/ForgotPassword/Index";
import CreateJob from "./pages/Jobs/CreateJob";
import CreateJobV2 from "./pages/Jobs/CreateJobV2";
import EditJob from "./pages/Jobs/EditJob";
import EditTask from "./pages/Jobs/EditTask";
import PipelinesList from "./pages/Jobs/PipelinesList";
import Login from "./pages/Login/login";
import ClientService from "./pages/ManageClients/ClientService";
import ClientSubscriptions from "./pages/ManageClients/ClientSubscriptions";
import ManageClients from "./pages/ManageClients/ManageClients";
import ResetPassword from "./pages/ResetPassword/Index";
import EditServiceForm from "./pages/ServiceForm/EditServiceForm";
import AllServices from "./pages/Services/AllServices";
import ServiceDepartments from "./pages/Services/ServiceDepartments";
import Services from "./pages/Services/Services";
import ServicesByDepartment from "./pages/Services/ServicesByDepartment";
import Settings from "./pages/Settings/Settings";
import CreateStateForm from "./pages/StateForm/CreateStateForm";
import CreateNewServiceWithJobs from "./pages/TaskForm/CreateNewServiceWithJobs";
import CreateTaskForm from "./pages/TaskForm/CreateTaskForm";
import EditTaskForm from "./pages/TaskForm/EditTaskForm";
import MyAssignments from "./pages/Tasks/MyAssignments";
import MyAssignmentsReportPage from "./pages/Tasks/MyAssignmentsReport";
import TeamsCreatePage from "./pages/Teams/TeamsCreatePage";
import TeamsDeletePage from "./pages/Teams/TeamsDeletePage";
import TeamsEditPage from "./pages/Teams/TeamsEditPage";
import TeamsListPage from "./pages/Teams/TeamsListPage";

function App() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get("Bearer")) {
            if (
                location.pathname !== "/" &&
                location.pathname !== "/register" &&
                location.pathname !== "/forgotPassword" &&
                location.pathname !== "/accept-invitation" &&
                !location.pathname.includes("resetPassword")
            ) {
                navigate("/");
            }
        } else {
            //console.log(Cookies.get('Bearer'));
            if (
                location.pathname === "/" ||
                location.pathname === "/register" ||
                location.pathname === "/forgotPassword" ||
                location.pathname === "/accept-invitation" ||
                location.pathname.includes("resetPassword")
            ) {
                if (location.pathname !== "/accept-invitation") {
                    navigate("/my-assignments-report");
                }
            }
        }

        document.querySelector("html").style.scrollBehavior = "auto";
        window.scroll({ top: 0 });
        document.querySelector("html").style.scrollBehavior = "";
        // eslint-disable-next-line
    }, [location.pathname]); // triggered on route change

    return (
        <Routes>
            <Route exact path="/" element={<Login />} />
            <Route path="/filteredClients" element={<FilteredClients />} />
            <Route path="/employeeServices" element={<EmployeeServices />} />

            <Route
                exact
                path="/clients/service/:clientServiceId/client/:clientId"
                element={<ClientService />}
            />
            {/*<Route exact path="/register" element={<RegisterNewUser />} />*/}
            <Route exact path="/services" element={<Services />} />
            <Route exact path="/services/:id" element={<EditServiceForm />} />
            <Route exact path="/services/old/:id" element={<EditServiceForm />} />
            <Route
                exact
                path="/services/:id/task/create"
                element={<CreateTaskForm />}
            />
            {/*   <Route
        exact
        path="/category/:id/job/create"
        element={<CreateJobForm />}
      /> */}
            <Route
                exact
                path="/services/:id/task/:task_id"
                element={<EditTaskForm />}
            />
            <Route exact path="/clients" element={<Clients />} />
            <Route exact path="/clients/create" element={<CreateClientForm />} />
            <Route exact path="/clients/manage" element={<ManageClients />} />
            <Route
                exact
                path="/clients/manage/:client_id"
                element={<ManageClients />}
            />
            <Route
                exact
                path="/clients/manage/:client_id/subscription/:id"
                element={<ClientSubscriptions />}
            />
            <Route exact path="/clients/:id" element={<EditClientForm />} />
            <Route exact path="/employees" element={<EmployeesPage />} />
            <Route exact path="/employees/:id" element={<EditEmployeeForm />} />
            <Route exact path="/employees/create" element={<AdminRoute><CreateEmployee /></AdminRoute>} />
            <Route
                exact
                path="/services/:id/state/create"
                element={<CreateStateForm />}
            />
            <Route exact path="/forgotPassword" element={<ForgotPassword />} />
            <Route exact path="/resetPassword/:id" element={<ResetPassword />} />
            <Route
                exact
                path="/accept-invitation"
                element={<AcceptInvitation />}
            />
            <Route
                exact
                path="/dashboards/tax-agenda-report"
                element={<TaxAgendaReport />}
            />
            <Route exact path="/dashboards/jobs-report" element={<JobsReport />} />
            <Route
                exact
                path="/dashboards/jobs-report-v2"
                element={<JobsReportV2 />}
            />
            <Route
                exact
                path="/dashboards/client-insights"
                element={<ClientInsights />}
            />
            <Route
                exact
                path="/dashboards/service-insights"
                element={<ServiceInsights />}
            />
            <Route
                exact
                path="/dashboards/accountability"
                element={<Accountability />}
            />
            <Route
                exact
                path="/dashboards/efile-status-report"
                element={<EfileStatusReport />}
            />
            <Route
                exact
                path="/dashboards/due-date-report"
                element={<DueDateReport />}
            />
            <Route
                exact
                path="/dashboards/status-report"
                element={<StatusReport />}
            />
            <Route
                exact
                path="/dashboards/employee-workload-report"
                element={<WorkloadReport />}
            />
            <Route
                exact
                path="/dashboards/employee-production-report"
                element={<EmployeeProductionReport />}
            />
            <Route
                exact
                path="/dashboards/inactive-report"
                element={<InactiveReport />}
            />

            <Route exact path="/settings" element={<Settings />} />
            <Route
                exact
                path="/admin/permissions"
                element={
                    <AdminRoute>
                        <Permissions />
                    </AdminRoute>
                }
            />
            <Route
                exact
                path="/my-assignments/:filterName"
                element={<MyAssignments />}
            />
            <Route
                exact
                path="/departments/create"
                element={<CreateDepartmentForm />}
            />
            <Route exact path="/departments/:id" element={<EditDepartmentForm />} />
            {/* <Route exact path="/categories" element={<Categories />} />
      <Route exact path="/categories/create" element={<CreateCategory />} />
      <Route exact path="/category/:id" element={<EditCategory />} />
      <Route
        exact
        path="/category/:categoryId/job/:jobId"
        element={<EditJobForm />}
      />
      <Route exact path="/templates/categories" element={<Categories />} /> */}
            {/* <Route exact path="/templates/services" element={<Services />} /> */}
            <Route exact path="/departments" element={<ServiceDepartments />} />
            <Route
                exact
                path="/templates/servicesByDepartment/:name"
                element={<ServicesByDepartment />}
            />
            <Route
                exact
                path="/templates/services/create"
                element={<CreateNewServiceWithJobs />}
            />
            <Route exact path="/templates/services" element={<AllServices />} />
            <Route exact path="/templates/jobs" element={<PipelinesList />} />
            <Route exact path="/templates/jobs/create" element={<CreateJob />} />
            <Route exact path="/templates/job/:jobId" element={<EditJob />} />
            <Route
                exact
                path="/templates/jobs/:jobId/task/:taskId"
                element={<EditTask />}
            />
            {/*  <Route
                exact
                path="/templates/jobs/:jobId/tasks/create"
                element={<CreateTask />}
            /> */}
            <Route
                exact
                path="/templates/job-templates/:jobId/jobs/create"
                element={<CreateJobV2 />}
            />
            <Route
                exact
                path="/my-assignments-report"
                element={<MyAssignmentsReportPage />}
            />

            <Route exact path="/teams" element={<TeamsListPage />} />
            <Route exact path="/teams/create" element={<TeamsCreatePage />} />
            <Route exact path="/teams/:id" element={<TeamsEditPage />} />
            <Route exact path="/teams/delete/:id" element={<TeamsDeletePage />} />

            <Route
                exact
                path="/dashboards/retention-report"
                element={<RetentionReport />}
            />
        </Routes>
    );
}
export default App;
